export const DASHBOARD_HEIGHT_SCALE = 0.9;

export function getDashboardHeightScale(element) {
  const row = element?.closest('.dashboard-card-row');
  if (!row) {
    return 1;
  }

  const scale = parseFloat(getComputedStyle(row).getPropertyValue('--dashboard-height-scale'));
  return Number.isFinite(scale) && scale > 0 ? scale : DASHBOARD_HEIGHT_SCALE;
}

export function computePieChartSize({
  clientWidth,
  clientHeight,
  legendItemCount,
  scale = 1,
  widthFactor = 1,
  legendPosition = 'side'
}) {
  if (clientWidth <= 0) {
    return null;
  }

  const effectiveWidth = clientWidth * widthFactor;

  if (legendPosition === 'bottom') {
    const gap = 16;
    const legendReserve = 12 + legendItemCount * 26;
    const maxByWidth = effectiveWidth;
    // Only constrain by height when the card is stretched taller than its
    // natural content (equal-height dashboard rows). On stacked mobile layouts
    // the body height includes the chart, so a height cap creates a shrink loop.
    const naturalContentHeight = legendReserve + gap + maxByWidth;
    const maxByHeight = clientHeight > naturalContentHeight
      ? clientHeight - legendReserve - gap
      : maxByWidth;
    const size = Math.min(maxByWidth, maxByHeight);

    if (size > 0) {
      return Math.floor(size * scale);
    }

    return null;
  }

  const gap = 32;
  const legendReserve = Math.min(effectiveWidth * 0.42, 72 + legendItemCount * 26);
  const maxByWidth = effectiveWidth - legendReserve - gap;
  const size = clientHeight > 80
    ? Math.min(maxByWidth, clientHeight)
    : maxByWidth;

  if (size > 0) {
    return Math.floor(size * scale);
  }

  return null;
}
